import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-checkout-address-page',
  templateUrl: './checkout-address-page.component.html',
  styleUrls: ['./checkout-address-page.component.css']
})
export class CheckoutAddressPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	$('#initialise-page').trigger('click');
  }

}
